module.exports = __webpack_public_path__ + "img/bg-services-landing-page-line.c809b6d8.svg";